import React from 'react';
let createReactClass = require("create-react-class");

const Interaction = createReactClass({
  componentDidMount() {
    this.props.layer.setInteraction(true);
    this.updateLayer(this.props)
  },
  componentWillReceiveProps(newProps) {
    this.removeCallbacks(this.props.layer);
    this.updateLayer(newProps);
  },
  updateLayer(props) {
    props.layer.setInteractivity(
      props.interactivity
    );
    this.addCallbacks(props);
  },
  addCallbacks({layer, interactivity, hover, click, hoverout}) {
    layer.setInteraction(true);
    if (click) {
      layer.on('featureClick', (e, latlng, pos, data) => click({e, latlng, pos, data}))
    }
    if (hover) {
      layer.on('featureOver', (e, latlng, pos, data) => hover({e, latlng, pos, data}))
    }
    if (hoverout) {
      layer.on('mouseout', hoverout );
      layer.leafletMap.on('mouseout', hoverout);
    }
  },
  removeCallbacks(layer) {
    layer.setInteraction(false)
    layer.off("featureOver");
    layer.off("mouseOut");
  },
  render() {
    return null;
  }
});

export default Interaction;



// WEBPACK FOOTER //
// ./components/Map/Interaction.js